import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'ucwords',
    standalone: true,
})
export class UcwordsPipe implements PipeTransform {
    transform(value: string): string {
        if (!value) {
            return '';
        }
        return value.toLowerCase().split(' ').map((word) => {
            if (word.indexOf('/') > -1) {
                const parts = word.split('/');
                const capitalized = [];
                for (const p of parts) {
                    capitalized.push(p.charAt(0).toUpperCase() + p.slice(1));
                }
                return capitalized.join('/');
            }

            return word.charAt(0).toUpperCase() + word.slice(1);
        }).join(' ');
    }
}
